import request from './request';

/**
 * 增量拉取直播间消息
 * @param {Object} params
 * @param {Number} params.video_id 视频/直播间ID
 * @param {Number} [params.since_id] 上次拉到的最大ID
 * @param {Number} [params.limit] 条数
 */
export function pullLiveChat(params) {
  return request.get('/api/live_chat/pull', { params });
}

/**
 * 发送聊天消息
 */
export function sendLiveChat(data) {
  return request.post('/api/live_chat/send', data);
}

/**
 * 进入直播间（写进场消息 + 首次心跳）
 */
export function enterLiveRoom(videoId) {
  return request.post('/api/live_chat/enter', { video_id: videoId });
}

/**
 * 心跳，维持在线状态
 */
export function liveHeartbeat(videoId) {
  return request.post('/api/live_chat/heartbeat', { video_id: videoId });
}

/**
 * 在线观众列表（含贵族/守护/粉丝身份）
 */
export function getLiveAudience(params) {
  return request.get('/api/live_chat/audience', { params });
}

/**
 * 在线人数与热度
 */
export function getLiveOnline(videoId) {
  return request.get('/api/live_chat/online', { params: { video_id: videoId } });
}

/**
 * 点赞（飘心）
 */
export function likeLiveRoom(videoId, count = 1) {
  return request.post('/api/live_chat/like', { video_id: videoId, count });
}
